/**
 * Small fetch wrapper for the Insights CMS API.
 * Attaches the JWT from localStorage when calling admin-protected endpoints.
 */
const BASE = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "insights_admin_token";

export function getToken() {
  return typeof window !== "undefined" ? window.localStorage.getItem(TOKEN_KEY) : null;
}
export function setToken(t) {
  if (t) window.localStorage.setItem(TOKEN_KEY, t);
  else window.localStorage.removeItem(TOKEN_KEY);
}

async function request(path, { method = "GET", body, auth = false } = {}) {
  const headers = { "Content-Type": "application/json" };
  if (auth) {
    const token = getToken();
    if (token) headers["Authorization"] = `Bearer ${token}`;
  }
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const detail = data?.detail;
    const msg = typeof detail === "string" ? detail : Array.isArray(detail) ? detail.map((e) => e.msg || JSON.stringify(e)).join(", ") : `HTTP ${res.status}`;
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }
  return data;
}

export const api = {
  // Auth
  login: (email, password) => request("/api/auth/login", { method: "POST", body: { email, password } }),
  me: () => request("/api/auth/me", { auth: true }),
  // Articles
  listArticles: (all = false) => request(`/api/insights/articles${all ? "?status=all" : ""}`, { auth: all }),
  getArticleBySlug: (slug) => request(`/api/insights/articles/slug/${slug}`),
  getArticleAdmin: (id) => request(`/api/insights/articles/${id}`, { auth: true }),
  createArticle: (payload) => request("/api/insights/articles", { method: "POST", body: payload, auth: true }),
  updateArticle: (id, payload) => request(`/api/insights/articles/${id}`, { method: "PUT", body: payload, auth: true }),
  deleteArticle: (id) => request(`/api/insights/articles/${id}`, { method: "DELETE", auth: true }),
  // Case studies
  listCases: (all = false) => request(`/api/insights/case-studies${all ? "?status=all" : ""}`, { auth: all }),
  getCaseBySlug: (slug) => request(`/api/insights/case-studies/slug/${slug}`),
  getCaseAdmin: (id) => request(`/api/insights/case-studies/${id}`, { auth: true }),
  createCase: (payload) => request("/api/insights/case-studies", { method: "POST", body: payload, auth: true }),
  updateCase: (id, payload) => request(`/api/insights/case-studies/${id}`, { method: "PUT", body: payload, auth: true }),
  deleteCase: (id) => request(`/api/insights/case-studies/${id}`, { method: "DELETE", auth: true }),
};
